import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import * as finalWizardActions from 'actions/finalWizardActions';
import actionTypes from 'constants/currentUserConstants';

class ConfirmationForm extends Component {
  static propTypes = {
    currentUser: ImmutablePropTypes.map.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToFinalStep: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  resendConfirmation = () => {
    if (!this.props.snapSell) this.props.saveDraft('preview');
    this.props.resendConfirmation(this.props.formValues.email);
  };

  onCancel = () => this.props.goToFinalStep("email");

  render() {
    const { formValues, currentUser, formIsLoading } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');

    return (
      <Card>
        <div className="card-header">
          <h4>Welcome back!</h4>
        </div>
        <CardBody>
          <p>
            We've found an account for <strong>{formValues.email}</strong>.
          </p>
          <p>
            But you haven't confirmed your account and set a password yet!
          </p>
          <p>
            We will have sent you a confirmation email when you signed up, but we can send you another one now.
          </p>
          <Button onClick={this.resendConfirmation} disabled={isLoading} block color="primary">
            {isLoading ? 'Please wait...' : 'Resend confirmation email'}
          </Button>
        </CardBody>
        <div className="row">
          <div className="col-12 text-right">
            <Button onClick={this.onCancel} color="link">Cancel</Button>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(finalWizardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/ConfirmationForm.jsx